import { produce } from 'immer';
import {
  ALL_MESSAGES_LOADED,
  LAST_MESSAGES_LOADED,
  RESET_MESSAGES,
} from './chat.actions';
import { IChatMessageDto } from '../../domain/chat.interfaces';

export const initialState: {
  messages: IChatMessageDto[];
  totalItems: number;
} = {
  messages: [],
  totalItems: 0,
};

export const chatReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case ALL_MESSAGES_LOADED:
        draft.messages = [...state.messages, ...action.payload.messages];
        draft.totalItems = action.payload.totalItems;
        return;
      case LAST_MESSAGES_LOADED:
        draft.messages = [...action.payload, ...state.messages];
        return;
      case RESET_MESSAGES:
        draft.messages = initialState.messages;
        draft.totalItems = initialState.totalItems;
    }
  });
